import { shape, string } from 'prop-types';
import { getEnv } from '../../../environment';
import OptimizelyProvider from '../../context/OptimizelyProvider';
import { useNmfRedirect } from '../../hooks/useNmfRedirect';
import { useNmfTimer } from '../../hooks/useNmfTimer';
import LogoHeader from '../components/LogoHeader';
import ProgressNav from '../components/ProgressNav';

// Rendered inside the OptimizelyProvider so the timer hooks can resolve the deprecation flag.
const IntroProductNavContent = ({ env }) => {
  const introProductSteps = [
    { title: 'Confirmation', url: '/gtb-thank-you/shipping' },
    { title: 'Survey', url: '/personal-survey' },
    { title: 'Done', url: null },
  ];

  const {
    lastVisitedCustomizeQuestionId,
    timerType,
    newMemberState,
    loading: timerLoading,
    isTimerDeprecated,
  } = useNmfTimer(env);

  useNmfRedirect(
    newMemberState,
    lastVisitedCustomizeQuestionId,
    env.REACT_APP_BASE_URL,
    timerType,
    isTimerDeprecated,
  );

  if (timerLoading) {
    return null;
  }

  return (
    <>
      <LogoHeader />
      <ProgressNav steps={introProductSteps} />
    </>
  );
};

IntroProductNavContent.propTypes = {
  env: shape({ REACT_APP_BASE_URL: string }).isRequired,
};

const IntroProductNav = (envName) => {
  const env = getEnv(envName);

  return (
    <OptimizelyProvider>
      <IntroProductNavContent env={env} />
    </OptimizelyProvider>
  );
};

export default IntroProductNav;
